// Meldingen op je telefoon (0038_meldingen; docs/DESIGN.md §8.PU). Handgeschreven zoals
// activity.ts en gelijk aan de API (apps/api/src/routes/v1/app/push.ts); openapi.contract.test.ts
// bewaakt elke aanroep. De endpoint-URL van een browser gaat alleen heen (aanmelden/afmelden),
// nooit terug.
const id = (value) => encodeURIComponent(value);
export function createPushClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const del = (path) => t.request('DELETE', path);
    return {
        settings: () => get('/v1/app/push'),
        savePreferences: (input) => put('/v1/app/push/preferences', input),
        subscribe: (sub) => post('/v1/app/push/subscriptions', sub),
        unsubscribe: (endpoint) => post('/v1/app/push/subscriptions/remove', { endpoint }),
        removeSubscription: (subscriptionId) => del(`/v1/app/push/subscriptions/${id(subscriptionId)}`),
        test: () => post('/v1/app/push/test', {}),
        setChild: (memberId, allowed) => put(`/v1/app/push/children/${id(memberId)}`, { allowed }),
    };
}
//# sourceMappingURL=push.js.map